import { RouterModule, Routes } from '@angular/router';
import { AppPersonaComponent } from "./app-persona/app-persona.component";
import { AppEmpresaComponent } from "./app-empresa/app-empresa.component";
import { PromotionsPersonComponent } from "./app-persona/promotions-person/promotions-person.component";
import { EspecialidadesPersonComponent } from "./app-persona/especialidades-person/especialidades-person.component";
import { ServiciosPersonComponent } from "./app-persona/servicios-person/servicios-person.component";
import { EspecialidadDetailsComponent } from "./app-persona/especialidades-person/especialidad-details/especialidad-details.component";
import { PromotionsDetailsComponent } from "./app-persona/promotions-person/promotions-details/promotions-details.component";
import { AppMktComponent } from "./app-mkt/app-mkt.component";
import { AuthGuard } from "./auth/auth.guard";
import { NormalizeRouteGuard } from "./auth/normalize-route.guard";
import { DashboardMktSamComponent } from "./app-mkt/dashboard-mkt/dashboard-mkt-sam.component";
import { PromocionesMktSamComponent } from "./app-mkt/dashboard-mkt/promociones-mkt-sam/promociones-mkt-sam.component";
import {DashboardMainComponent} from "./app-mkt/dashboard-mkt/dashboard-main/dashboard-main.component";
import {PromocionesMktWebComponent} from "./app-mkt/dashboard-mkt/promociones-mkt-web/promociones-mkt-web.component";
import {EspecialidadesComponent} from "./app-mkt/dashboard-mkt/especialidades/especialidades.component";
import {MoviLinkComponent} from "./app-persona/movi-link/movi-link.component";
import {OnLinkComponent} from "./app-persona/on-link/on-link.component";
import { TerapiaFisicaComponent } from "./app-persona/terapia-fisica/terapia-fisica.component";
import {AmbulanciaComponent} from "./app-persona/ambulancia/ambulancia.component";
import {AboutUsComponent} from "./app-persona/about-us/about-us.component";
import {SucursalHorariosComponent} from "./app-mkt/dashboard-mkt/sucursal-horarios/sucursal-horarios.component";
import {PoliticsPrivacityComponent} from "./politics-privacity/politics-privacity.component";
import {UsuariosComponent} from "./app-mkt/dashboard-mkt/usuarios/usuarios.component";
import {RoleGuard} from "./auth/role.guard";
import {HerosHomeComponent} from "./app-mkt/dashboard-mkt/heros-home/heros-home.component";
import {AppDocumentsComponent} from "./app-documents/app-documents.component";
import {HowToApplyServiceComponent} from "./app-persona/movi-link/how-to-apply-service/how-to-apply-service.component";
import {ContactanosComponent} from "./app-persona/contactanos/contactanos.component";
import {BotiquinEmpresarialComponent} from "./app-empresa/botiquin-empresarial/botiquin-empresarial.component";
import {ServicioAmbulanciaComponent} from "./app-empresa/servicio-ambulancia/servicio-ambulancia.component";
import {
  TerapiaFisicaYTraumotologicaComponent
} from "./app-empresa/terapia-fisica-ytraumotologica/terapia-fisica-ytraumotologica.component";
import {FeriasCharlasSaludComponent} from "./app-empresa/ferias-charlas-salud/ferias-charlas-salud.component";
import {MedicoDispensarioComponent} from "./app-empresa/medico-dispensario/medico-dispensario.component";
import {
  ExamenesPrePostOcupacionalComponent
} from "./app-empresa/examenes-pre-post-ocupacional/examenes-pre-post-ocupacional.component";
import {NutricionDieteticaComponent} from "./app-empresa/nutricion-dietetica/nutricion-dietetica.component";
import {ExamenesPeriodicosComponent} from "./app-empresa/examenes-periodicos/examenes-periodicos.component";
import {PsicologiaSaludMentalComponent} from "./app-empresa/psicologia-salud-mental/psicologia-salud-mental.component";
import {AllMainComponent} from "./app-empresa/home/all-main/all-main.component";


export const routes: Routes = [
  { path: '', component: AppPersonaComponent },
  { path: 'persona', component: AppPersonaComponent },
  { path: 'movilink', component: MoviLinkComponent},
  { path: 'onlink', component: OnLinkComponent },
  { path: 'terapiafisica', component: TerapiaFisicaComponent },
  /* Rutas Empresa */

  { path: 'empresa',
    children:[
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'botiquin-empresarial', component: BotiquinEmpresarialComponent },
      { path: 'servicio-ambulancia', component: ServicioAmbulanciaComponent },
      { path: 'terapia-fisica-traumotologia', component: TerapiaFisicaYTraumotologicaComponent },
      { path: 'ferias-charlas-salud', component: FeriasCharlasSaludComponent },
      { path: 'medicos-para-dispensario', component: MedicoDispensarioComponent },
      { path: 'examenes-pre-post-ocupacional', component: ExamenesPrePostOcupacionalComponent },
      { path: 'nutricion-dietetica', component: NutricionDieteticaComponent },
      { path: 'examenes-ocupacionales-periodicos', component: ExamenesPeriodicosComponent },
      { path: 'terapia-psicologica-salud-mental', component: PsicologiaSaludMentalComponent },
      {path: 'home', component: AllMainComponent}
    ],
    component: AppEmpresaComponent,

  },
  /* Fin Rutas Empresa */

  { path: 'promociones', component: PromotionsPersonComponent },
  { path: 'nosotros', component: AboutUsComponent },
  { path: 'ambulancia', component: AmbulanciaComponent },
  { path: 'promociones/:cod_descuentos', component: PromotionsDetailsComponent },
  { path: 'servicios', component: ServiciosPersonComponent },
  { path: 'especialidades', component: EspecialidadesPersonComponent },
  { path: 'contactanos', component: ContactanosComponent },
  { path: 'especialidades/:namespecialidad', component: EspecialidadDetailsComponent, canActivate:[ NormalizeRouteGuard ] },
  { path: 'politica-privacidad', component: PoliticsPrivacityComponent },
  { path: 'mktmedilink', component: AppMktComponent },
  { path: 'uploadDocuments/:hashedPassword/:codOrden', component: AppDocumentsComponent },
  {
    path: 'dashboardmkt',
    component: DashboardMktSamComponent,
    canActivate: [AuthGuard],
    // pathMatch: 'full',
    children: [
      {
        path: '',
        component: DashboardMainComponent,
        // canActivate: [AuthGuard]

      },
      {
        path: 'promocionesSam',
        component: PromocionesMktSamComponent,
        // canActivate: [AuthGuard]
      },
      {
        path: 'promocionesWeb',
        component: PromocionesMktWebComponent,
        // canActivate: [AuthGuard]
      },
      {
        path: 'especialidadesWeb',
        component: EspecialidadesComponent,
        // canActivate: [AuthGuard]
      },
      {
        path: 'sucursalesHorarios',
        component: SucursalHorariosComponent,
        // canActivate: [AuthGuard]
      },
      {
        path: 'herosHome',
        component: HerosHomeComponent,
        // canActivate: [AuthGuard]
      },
      {
        path: 'usuariosmkt',
        component: UsuariosComponent,
        canActivate: [RoleGuard]
      }
    ]
  },

  { path: '**', redirectTo: '' } // redirige a la página principal
];


